<template>
    <div
        class="message"
        v-bind:class="`status-${status}`"
        v-bind:style="style"
        v-on:click="clearTopScreenToast"
    >
        {{ translatedMessage }}
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import type { PropType } from 'vue';
    import { computed, defineComponent } from 'vue';
    import { i18n } from '@/libraries/i18n';
    import { useHeaderDisplayStore } from '@/stores/headerDisplayStore';
    import { useRootStore } from '@/stores/rootStore';

    export default defineComponent({
        name: 'Message',
        props: {
            messageKey: {
                type: String,
                default: '',
            },
            messageData: {
                type: Object as PropType<Record<string, string | number> | null>,
                default: null,
            },
            status: {
                type: String as PropType<'success' | 'error' | 'warning' | 'placeBetSuccess'>,
                default: 'success',
            },
        },
        setup(props) {
            const { clearTopScreenToast } = useRootStore();

            const { sportsFooterHeight } = storeToRefs(useHeaderDisplayStore());

            const translatedMessage = computed(() => i18n.t(props.messageKey, props.messageData ?? {}));

            const style = computed(() => (props.status === 'placeBetSuccess'
                ? {
                    'bottom': `${sportsFooterHeight.value + 10}px`,
                    'margin-bottom': 0,
                }
                : {}));

            return {
                i18n,
                clearTopScreenToast,
                sportsFooterHeight,
                translatedMessage,
                style,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/components/message";
</style>
